import type { FC } from 'react';
import { observer } from 'mobx-react-lite';

import { ButtonDefault } from '@sbol/nova';
import styles from './Button.module.scss';
import clsx from 'clsx';

type Props = {
  onClick?: (() => void) | null;
  text?: string | null;
  className?: string | null;
  isLoading?: boolean;
  disabled?: boolean;
  isLink?: boolean;
  href?: string | null;
};

/**
 * Простая зеленая кнопка.
 *
 * isLink - делает из кнопки ссылку того же вида. \
 * disabled - делает кнопку серой, отключает onClick. \
 * isLoading - тоже, что и disabled + внутри появляет лоадер.
 */
export const Button: FC<Props> = observer((props) => {
  const { onClick, text, className, isLoading, disabled: _disabled, href, isLink } = props;

  const disabled = _disabled || isLoading;

  return (
    <ButtonDefault
      // без tabIndex в консоли будет предупреждение
      tabIndex={0}
      title={text}
      // isLoading блокирует срабатывание onClick при клике, но не при нажатии Enter
      isLoading={isLoading}
      // disabled блокирует срабатывание onClick при нажатии Enter, но не при клике
      disabled={disabled}
      disableVerticalIndents
      disableHorizontalIndents
      onClick={(!disabled && onClick) || undefined}
      ElementType={isLink ? 'a' : undefined}
      href={href || undefined}
      className={clsx(styles.Button, className)}
    />
  );
});
